// extracted by mini-css-extract-plugin
module.exports = {"root":"AccommodationBlock_root__65gjA"};